import { FC, useCallback, useRef, useState } from 'react'
import { HexColorPicker } from 'react-colorful'

import ColorLensIcon from '@mui/icons-material/ColorLens'
import { Box, IconButton } from '@mui/material'

import { useField, useFormikContext } from 'formik'

import useClickOutside from 'utils/customHooks/useClickOutside'
import { BG_DARK_GRAY, ELEMENT_RADIUS_MID } from 'utils/customizedTheme'

import { IFieldProps } from 'types'

import InputField from './InputField'

interface IProps {
  fieldProps: IFieldProps
  disabled: boolean
}

const ColorPickerField: FC<IProps> = ({ fieldProps, disabled }) => {
  const [showPicker, setShowPicker] = useState(false)

  const [field, meta] = useField(fieldProps.name)
  const { setFieldValue } = useFormikContext()
  const { touched, error } = meta
  const [color, setColor] = useState(field.value)
  const togglePicker = () => {
    setShowPicker(!showPicker)
  }

  return (
    <Box
      id='picker-field'
      sx={{
        position: 'relative',
        borderRadius: ELEMENT_RADIUS_MID,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    >
      <InputField fieldProps={{ ...fieldProps }} disabled={disabled} clearRight='5.5rem' />
      <IconButton
        onClick={togglePicker}
        sx={{
          position: 'absolute',
          top: '0.17rem',
          right: '3rem',
        }}
      >
        <ColorLensIcon
          sx={{
            color: 'rgba(0, 0, 0, 0.54)',
            fontSize: '1.7rem',
            rotate: '-15deg',
            opacity: disabled ? '0.5' : '1',
          }}
        />
      </IconButton>
      <div
        style={{
          position: 'absolute',
          top: '1px',
          right: '1px',
          background: field.value,
          width: '2.9rem',
          height: '2.85rem',
          borderRadius: ELEMENT_RADIUS_MID,
          borderLeft: `1px solid ${BG_DARK_GRAY}`,
          cursor: 'pointer',
        }}
        onClick={togglePicker}
        id='picker-box'
      />
      {showPicker && (
        <PopoverPicker
          showPicker={showPicker}
          setShowPicker={setShowPicker}
          color={color}
          onChange={(value) => {
            if(value==='#NaNNaNNaN'){
              setColor('#ff0000')
              setFieldValue(field.name, '')
            }else{
              setColor(value)
              setFieldValue(field.name, value)
            }
          
          }}
        />
      )}
    </Box>
  )
}
export default ColorPickerField

const PopoverPicker = ({ color, onChange, showPicker, setShowPicker }) => {
  const popover = useRef()

  const close = useCallback(() => setShowPicker(false), [])
  useClickOutside(popover, close)

  return (
    showPicker && (
      <div className='popover' ref={popover}>
        <HexColorPicker
          color={color}
          onChange={onChange}
          style={{ position: 'absolute', bottom: '2.9rem', right: '0', zIndex: '10' }}
        />
      </div>
    )
  )
}
